'use client';

import React, { useState } from 'react';
import {
  Search, Filter, Download, ChevronUp, ChevronDown,
  MoreHorizontal, CheckCircle, Clock, XCircle, Eye,
  Edit2, Trash2, ChevronLeft, ChevronRight
} from 'lucide-react';
import { toast } from 'sonner';

// Backend integration point: GET /api/hotels/:id/bookings?page=1&limit=10&status=...
const allBookings = [
  {
    id: 'bk-2026-001',
    guest: 'Thomas Müller',
    nationality: '🇩🇪 German',
    email: 'thomas.muller@gmail.com',
    court: 'Court 1',
    date: '19/04/2026',
    timeSlot: '08:00 – 09:00',
    duration: '1h',
    players: 4,
    amount: 65,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: false,
  },
  {
    id: 'bk-2026-002',
    guest: 'Marie Dupont',
    nationality: '🇫🇷 French',
    email: 'marie.dupont@outlook.fr',
    court: 'Court 1',
    date: '19/04/2026',
    timeSlot: '10:00 – 11:30',
    duration: '1.5h',
    players: 2,
    amount: 97,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: true,
  },
  {
    id: 'bk-2026-003',
    guest: 'James Wilson',
    nationality: '🇬🇧 British',
    email: 'j.wilson@btinternet.com',
    court: 'Court 2',
    date: '19/04/2026',
    timeSlot: '09:00 – 10:00',
    duration: '1h',
    players: 4,
    amount: 65,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: false,
  },
  {
    id: 'bk-2026-004',
    guest: 'Sophie Laurent',
    nationality: '🇫🇷 French',
    email: 'sophie.laurent@free.fr',
    court: 'Court 1',
    date: '19/04/2026',
    timeSlot: '16:00 – 17:00',
    duration: '1h',
    players: 2,
    amount: 65,
    status: 'pending',
    paymentStatus: 'pending',
    bundle: false,
  },
  {
    id: 'bk-2026-005',
    guest: 'Karim Ben Salah',
    nationality: '🇹🇳 Tunisian',
    email: 'karim.bensalah@topnet.tn',
    court: 'Court 3',
    date: '19/04/2026',
    timeSlot: '08:00 – 10:00',
    duration: '2h',
    players: 4,
    amount: 130,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: false,
  },
  {
    id: 'bk-2026-006',
    guest: 'Emma Petit',
    nationality: '🇫🇷 French',
    email: 'emma.petit@laposte.net',
    court: 'Court 3',
    date: '19/04/2026',
    timeSlot: '11:00 – 12:00',
    duration: '1h',
    players: 4,
    amount: 65,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: true,
  },
  {
    id: 'bk-2026-007',
    guest: 'Anna Kowalski',
    nationality: '🇵🇱 Polish',
    email: 'a.kowalski@wp.pl',
    court: 'Court 2',
    date: '20/04/2026',
    timeSlot: '09:00 – 10:30',
    duration: '1.5h',
    players: 2,
    amount: 97,
    status: 'pending',
    paymentStatus: 'pending',
    bundle: false,
  },
  {
    id: 'bk-2026-008',
    guest: 'Marco Bianchi',
    nationality: '🇮🇹 Italian',
    email: 'marco.bianchi@libero.it',
    court: 'Court 3',
    date: '19/04/2026',
    timeSlot: '18:00 – 19:00',
    duration: '1h',
    players: 4,
    amount: 65,
    status: 'pending',
    paymentStatus: 'pending',
    bundle: false,
  },
  {
    id: 'bk-2026-009',
    guest: 'Lena Schneider',
    nationality: '🇩🇪 German',
    email: 'lena.schneider@web.de',
    court: 'Court 1',
    date: '19/04/2026',
    timeSlot: '19:00 – 21:00',
    duration: '2h',
    players: 4,
    amount: 130,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: true,
  },
  {
    id: 'bk-2026-010',
    guest: 'Carlos Ruiz',
    nationality: '🇪🇸 Spanish',
    email: 'c.ruiz@telefonica.es',
    court: 'Court 2',
    date: '19/04/2026',
    timeSlot: '18:00 – 19:00',
    duration: '1h',
    players: 2,
    amount: 65,
    status: 'cancelled',
    paymentStatus: 'refunded',
    bundle: false,
  },
  {
    id: 'bk-2026-011',
    guest: 'Lisa Hoffmann',
    nationality: '🇩🇪 German',
    email: 'lisa.hoffmann@gmx.de',
    court: 'Court 3',
    date: '20/04/2026',
    timeSlot: '20:00 – 21:30',
    duration: '1.5h',
    players: 4,
    amount: 97,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: false,
  },
  {
    id: 'bk-2026-012',
    guest: 'Pierre Martin',
    nationality: '🇫🇷 French',
    email: 'pierre.martin@orange.fr',
    court: 'Court 2',
    date: '20/04/2026',
    timeSlot: '14:00 – 15:30',
    duration: '1.5h',
    players: 4,
    amount: 97,
    status: 'confirmed',
    paymentStatus: 'paid',
    bundle: true,
  },
];

const statusConfig: Record<string, { label: string; className: string; icon: React.ReactNode }> = {
  confirmed: {
    label: 'Confirmed',
    className: 'text-green-700 bg-green-50 border-green-200',
    icon: <CheckCircle size={11} />,
  },
  pending: {
    label: 'Pending',
    className: 'text-amber-700 bg-amber-50 border-amber-200',
    icon: <Clock size={11} />,
  },
  cancelled: {
    label: 'Cancelled',
    className: 'text-red-700 bg-red-50 border-red-200',
    icon: <XCircle size={11} />,
  },
};

const paymentConfig: Record<string, { label: string; className: string }> = {
  paid: { label: 'Paid', className: 'text-green-700 bg-green-50 border-green-200' },
  pending: { label: 'Pending', className: 'text-amber-700 bg-amber-50 border-amber-200' },
  refunded: { label: 'Refunded', className: 'text-muted-foreground bg-muted border-border' },
};

type SortKey = 'guest' | 'date' | 'amount' | 'status';

export default function BookingsTable() {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortKey, setSortKey] = useState<SortKey>('date');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [page, setPage] = useState(1);
  const [actionMenuId, setActionMenuId] = useState<string | null>(null);
  const [statusDropdownId, setStatusDropdownId] = useState<string | null>(null);
  const [bookings, setBookings] = useState(allBookings);
  const perPage = 8;

  const filtered = bookings.filter((b) => {
    const matchSearch =
      b.guest.toLowerCase().includes(search.toLowerCase()) ||
      b.id.toLowerCase().includes(search.toLowerCase()) ||
      b.nationality.toLowerCase().includes(search.toLowerCase());
    const matchStatus = statusFilter === 'all' || b.status === statusFilter;
    return matchSearch && matchStatus;
  });

  const sorted = [...filtered].sort((a, b) => {
    let cmp = 0;
    if (sortKey === 'guest') cmp = a.guest.localeCompare(b.guest);
    else if (sortKey === 'date') cmp = a.date.localeCompare(b.date);
    else if (sortKey === 'amount') cmp = a.amount - b.amount;
    else if (sortKey === 'status') cmp = a.status.localeCompare(b.status);
    return sortDir === 'asc' ? cmp : -cmp;
  });

  const totalPages = Math.ceil(sorted.length / perPage);
  const paginated = sorted.slice((page - 1) * perPage, page * perPage);

  const toggleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir('asc'); }
  };

  const toggleSelect = (id: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleSelectAll = () => {
    if (selected.size === paginated.length) setSelected(new Set());
    else setSelected(new Set(paginated.map((b) => b.id)));
  };

  const handleStatusChange = (bookingId: string, newStatus: string) => {
    setBookings((prev) =>
      prev.map((b) => b.id === bookingId ? { ...b, status: newStatus } : b)
    );
    setStatusDropdownId(null);
    toast.success(`Booking ${bookingId} status updated to ${newStatus}`);
  };

  const handleDelete = (bookingId: string) => {
    setBookings((prev) => prev.filter((b) => b.id !== bookingId));
    setActionMenuId(null);
    toast.success(`Booking ${bookingId} removed`);
  };

  const handleBulkDelete = () => {
    setBookings((prev) => prev.filter((b) => !selected.has(b.id)));
    toast.success(`${selected.size} booking${selected.size > 1 ? 's' : ''} deleted`);
    setSelected(new Set());
  };

  const SortIcon = ({ col }: { col: SortKey }) => (
    <span className="ml-1 inline-flex flex-col">
      <ChevronUp size={10} className={sortKey === col && sortDir === 'asc' ? 'text-primary' : 'text-muted-foreground/40'} />
      <ChevronDown size={10} className={sortKey === col && sortDir === 'desc' ? 'text-primary' : 'text-muted-foreground/40'} />
    </span>
  );

  return (
    <div className="bg-white rounded-2xl border border-border shadow-card">
      {/* Table Header */}
      <div className="px-5 py-4 border-b border-border flex items-center justify-between flex-wrap gap-3">
        <div>
          <h3 className="text-base font-semibold text-foreground">All Bookings</h3>
          <p className="text-xs text-muted-foreground mt-0.5">{filtered.length} total · Showing page {page} of {totalPages}</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {/* Search */}
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
              placeholder="Search guest, ID, nationality..."
              className="pl-8 pr-4 py-2 text-sm bg-muted rounded-xl border-0 focus:outline-none focus:ring-2 focus:ring-primary/30 w-56 placeholder:text-muted-foreground/60"
            />
          </div>

          {/* Status Filter */}
          <div className="flex rounded-xl border border-border overflow-hidden text-xs font-medium">
            {['all', 'confirmed', 'pending', 'cancelled'].map((s) => (
              <button
                key={`filter-${s}`}
                onClick={() => { setStatusFilter(s); setPage(1); }}
                className={`px-3 py-2 capitalize transition-colors ${
                  statusFilter === s ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'
                }`}
              >
                {s === 'all' ? 'All' : s}
              </button>
            ))}
          </div>

          {/* Export */}
          <button
            onClick={() => toast.success('Bookings exported as CSV')}
            className="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-border text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
          >
            <Download size={13} />
            Export
          </button>
        </div>
      </div>

      {/* Bulk Action Bar */}
      {selected.size > 0 && (
        <div className="px-5 py-3 bg-primary/5 border-b border-primary/20 flex items-center justify-between animate-slide-up">
          <span className="text-sm font-medium text-primary">{selected.size} booking{selected.size > 1 ? 's' : ''} selected</span>
          <div className="flex items-center gap-2">
            <button
              onClick={() => { selected.forEach((id) => handleStatusChange(id, 'confirmed')); setSelected(new Set()); }}
              className="px-3 py-1.5 rounded-lg bg-primary text-primary-foreground text-xs font-semibold hover:bg-primary/90 transition-colors"
            >
              Confirm All
            </button>
            <button
              onClick={handleBulkDelete}
              className="px-3 py-1.5 rounded-lg bg-destructive/10 text-destructive text-xs font-semibold hover:bg-destructive/20 transition-colors"
            >
              Delete Selected
            </button>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/30">
              <th className="px-4 py-3 w-10">
                <input
                  type="checkbox"
                  checked={selected.size === paginated.length && paginated.length > 0}
                  onChange={toggleSelectAll}
                  className="rounded accent-primary"
                />
              </th>
              <th className="px-4 py-3 text-left">
                <button onClick={() => toggleSort('guest')} className="flex items-center text-xs font-semibold uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
                  Guest <SortIcon col="guest" />
                </button>
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Court</th>
              <th className="px-4 py-3 text-left">
                <button onClick={() => toggleSort('date')} className="flex items-center text-xs font-semibold uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
                  Date <SortIcon col="date" />
                </button>
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Time Slot</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Duration</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Players</th>
              <th className="px-4 py-3 text-left">
                <button onClick={() => toggleSort('amount')} className="flex items-center text-xs font-semibold uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
                  Amount <SortIcon col="amount" />
                </button>
              </th>
              <th className="px-4 py-3 text-left">
                <button onClick={() => toggleSort('status')} className="flex items-center text-xs font-semibold uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
                  Status <SortIcon col="status" />
                </button>
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Payment</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Bundle</th>
              <th className="px-4 py-3 w-12" />
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {paginated.map((booking, rowIdx) => {
              const status = statusConfig[booking.status];
              const payment = paymentConfig[booking.paymentStatus];
              return (
                <tr
                  key={booking.id}
                  className={`group hover:bg-muted/40 transition-colors ${rowIdx % 2 === 0 ? '' : 'bg-muted/10'}`}
                >
                  <td className="px-4 py-3">
                    <input
                      type="checkbox"
                      checked={selected.has(booking.id)}
                      onChange={() => toggleSelect(booking.id)}
                      className="rounded accent-primary"
                    />
                  </td>
                  <td className="px-4 py-3">
                    <div>
                      <p className="text-sm font-semibold text-foreground">{booking.guest}</p>
                      <p className="text-xs text-muted-foreground">{booking.nationality}</p>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm font-medium text-foreground">{booking.court}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm text-foreground font-mono tabular-nums">{booking.date}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm text-foreground font-mono tabular-nums whitespace-nowrap">{booking.timeSlot}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm font-medium text-foreground font-mono tabular-nums">{booking.duration}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm text-foreground tabular-nums">{booking.players}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm font-bold text-foreground font-mono tabular-nums">{booking.amount} TND</span>
                  </td>
                  <td className="px-4 py-3 relative">
                    <button
                      onClick={() => setStatusDropdownId(statusDropdownId === booking.id ? null : booking.id)}
                      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold transition-all duration-150 hover:opacity-80 ${status.className}`}
                    >
                      {status.icon}
                      {status.label}
                    </button>
                    {statusDropdownId === booking.id && (
                      <div className="absolute left-0 top-full mt-1 w-36 bg-white rounded-xl shadow-card-hover border border-border py-1 z-30 animate-fade-in">
                        {['confirmed', 'pending', 'cancelled'].map((s) => (
                          <button
                            key={`status-opt-${s}`}
                            onClick={() => handleStatusChange(booking.id, s)}
                            className={`w-full text-left px-3 py-2 text-xs font-medium capitalize transition-colors hover:bg-muted ${booking.status === s ? 'text-primary font-semibold' : 'text-foreground'}`}
                          >
                            {s}
                          </button>
                        ))}
                      </div>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full border text-xs font-semibold ${payment.className}`}>
                      {payment.label}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    {booking.bundle ? (
                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
                        Stay & Play
                      </span>
                    ) : (
                      <span className="text-xs text-muted-foreground">—</span>
                    )}
                  </td>
                  <td className="px-4 py-3 relative">
                    <button
                      onClick={() => setActionMenuId(actionMenuId === booking.id ? null : booking.id)}
                      className="opacity-0 group-hover:opacity-100 p-1.5 rounded-lg hover:bg-muted transition-all duration-150"
                    >
                      <MoreHorizontal size={15} className="text-muted-foreground" />
                    </button>
                    {actionMenuId === booking.id && (
                      <div className="absolute right-4 top-full mt-1 w-40 bg-white rounded-xl shadow-card-hover border border-border py-1 z-30 animate-fade-in">
                        <button
                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-foreground hover:bg-muted transition-colors"
                          onClick={() => { setActionMenuId(null); toast.info(`Viewing booking ${booking.id}`); }}
                        >
                          <Eye size={13} /> View Details
                        </button>
                        <button
                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-foreground hover:bg-muted transition-colors"
                          onClick={() => { setActionMenuId(null); toast.info(`Editing booking ${booking.id}`); }}
                        >
                          <Edit2 size={13} /> Edit Booking
                        </button>
                        <div className="border-t border-border my-1" />
                        <button
                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-medium text-destructive hover:bg-destructive/5 transition-colors"
                          onClick={() => handleDelete(booking.id)}
                        >
                          <Trash2 size={13} /> Delete — cannot undo
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Empty State */}
        {paginated.length === 0 && (
          <div className="py-16 text-center">
            <div className="w-12 h-12 rounded-2xl bg-muted flex items-center justify-center mx-auto mb-3">
              <Search size={20} className="text-muted-foreground" />
            </div>
            <p className="text-sm font-semibold text-foreground">No bookings found</p>
            <p className="text-xs text-muted-foreground mt-1">
              Try adjusting your search or filter — no bookings match your current criteria.
            </p>
          </div>
        )}
      </div>

      {/* Pagination */}
      <div className="px-5 py-4 border-t border-border flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">Rows per page:</span>
          <select className="px-2 py-1 rounded-lg border border-border text-xs font-medium focus:outline-none focus:ring-1 focus:ring-primary/30 bg-white">
            {[8, 12, 20, 50].map((n) => (
              <option key={`perpage-${n}`}>{n}</option>
            ))}
          </select>
          <span className="text-xs text-muted-foreground ml-2">
            {(page - 1) * perPage + 1}–{Math.min(page * perPage, filtered.length)} of {filtered.length}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <button
            onClick={() => setPage(Math.max(1, page - 1))}
            disabled={page === 1}
            className="p-2 rounded-lg hover:bg-muted transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <ChevronLeft size={15} />
          </button>
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={`page-btn-${i + 1}`}
              onClick={() => setPage(i + 1)}
              className={`w-8 h-8 rounded-lg text-xs font-semibold transition-all duration-150 ${
                page === i + 1 ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'
              }`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => setPage(Math.min(totalPages, page + 1))}
            disabled={page === totalPages}
            className="p-2 rounded-lg hover:bg-muted transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <ChevronRight size={15} />
          </button>
        </div>
      </div>
    </div>
  );
}